<template>
    <div class="order-items-list">
        <OrderItem
            v-for="item in props.orderItems"
            :key="item.id"
            :item="item"
            :quantityDigits="orderItemsQuantityDigits"
            :showInternalNames="props.showInternalNames"
            :isWaiterOrAdmin="props.isWaiterOrAdmin"
            :alwaysShowGroupName="props.alwaysShowGroupName"
        />
    </div>
</template>

<script setup lang="ts">
    import type { IOrderItem } from "@/data/model/Order";
    import { computed } from "vue";

    import OrderItem from "./OrderItem.vue";

    // define properties
    const props = defineProps<{
        orderItems: IOrderItem[];
        showInternalNames: boolean;
        isWaiterOrAdmin: boolean;
        alwaysShowGroupName?: boolean;
    }>();

    // define computed
    const orderItemsQuantityDigits = computed(() => {
        let maxLength = 1;
        for (const item of props.orderItems) {
            const itemDigits = item.quantity.toString().length;
            maxLength = Math.max(maxLength, itemDigits);
        }
        return maxLength;
    });
</script>

<style scoped lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .order-items-list {
        font-size: 16px;
        color: colors.$fontColor;
    }
</style>
